<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background">
    </div>

    <button 
      class="modal-close is-large" 
      aria-label="close"
      @click="close()">
    </button>
    
    <div class="modal-content">

      <div class="box py-6">
        <div class="subtitle is-6 has-text-centered">
          Please leave a rating for the service you received
          <span v-if="companyName"> from {{companyName}}</span>
        </div>
        <div class="rating">
          <template v-for="ratingValue in ratings">  
            <input
              :key="ratingValue"
              :id="`rating-${ratingValue}`" 
              type="radio" 
              name="rating" 
              :value="ratingValue"
              @input="updateRating($event.target.value)"/>
            <label 
              :key="`icon-${ratingValue}`" 
              :for="`rating-${ratingValue}`">
              <i class="fas fa-2x fa-star"></i>
            </label>
          </template>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    rating: {
      type: [String, Number]
    },
    companyName: {
      type: String
    }
  },
  data() {
    return {
      ratings: [5,4,3,2,1]
    }
  },
  methods: {
    updateRating(v) {
      this.$emit('update:rating', v);
      this.close();
    }, 
    close() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
.rating {
	direction: rtl;
	unicode-bidi: bidi-override;
  color: gainsboro;
  text-align: center;
}

.rating input {
	display: none;
}

.rating label:hover,
.rating label:hover ~ label,
.rating input:checked + label,
.rating input:checked + label ~ label {
	color: #ffc107;
}

.modal-content {
  width: 380px;
}
</style>